import React from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
  Button, FormGroup, Form, Input,
} from 'reactstrap';
import {
  staticConstants, regexPattern, NUMERIC_VALUE, validationMessages,
} from '../../../utils/constants';
import InputError from '../elments/InputError';
import { addHttpInUrl } from '../../../utils';

function CompleteBetaPost(props) {
  const {
    betaPostData, handlePublishBetaPost,
  } = props;
  const {
    register, errors, handleSubmit,
  } = useForm({ mode: 'onBlur', nativeValidation: false });

  const onSubmit = (data) => {
    const queryObj = {
      segmentId: betaPostData.segmentId,
    };
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        queryObj[key] = addHttpInUrl(data[key]);
      }
    });
    handlePublishBetaPost(queryObj);
  };

  /* function to render the complete section where the shared urls will be asked in text fields */
  const renderCompleteSection = () => (
    <div className="modal-offer-detail-timeline-data">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="post-complete">
          <div className="post-complete-head">
            <h4>If you have already shared on your social media, please copy and paste your url in the field to mark this post as complete. </h4>
            <Button
              type="submit"
              color="publish"
            >
              Complete post
            </Button>
          </div>
          {
              betaPostData && betaPostData.shareType.instagram
            && (
            <FormGroup className={errors.instagramUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Input
                type="text"
                placeholder="Enter url"
                name="instagramUrl"
                innerRef={register({
                  required: true,
                  type: 'text',
                  pattern: { value: regexPattern.INSTAGRAM, message: validationMessages.INSTAGRAM },
                })}
              />
              <span className="input-icon instagram" />
              <InputError error={errors.instagramUrl} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
            </FormGroup>
            )
            }
          {
              betaPostData && betaPostData.shareType.facebook
            && (
            <FormGroup className={errors.facebookUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Input
                type="text"
                placeholder="Enter url"
                name="facebookUrl"
                innerRef={register({
                  required: true,
                  type: 'text',
                  pattern: { value: regexPattern.FACEBOOK, message: validationMessages.FACEBOOK },
                })}
              />
              <span className="input-icon facebook" />
              <InputError error={errors.facebookUrl} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.TEN} />

            </FormGroup>
            )
            }
          {
              betaPostData && betaPostData.shareType.twitter
            && (
            <FormGroup className={errors.twitterUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Input
                type="text"
                placeholder="Enter url"
                name="twitterUrl"
                innerRef={register({
                  required: true,
                  type: 'text',
                  pattern: { value: regexPattern.TWITTER, message: validationMessages.TWITTER },
                })}
              />
              <span className="input-icon twitter" />
              <InputError error={errors.twitterUrl} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
            </FormGroup>
            )
            }
          {
              betaPostData && betaPostData.shareType.youtube
            && (
            <FormGroup className={errors.youtubeUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Input
                type="text"
                placeholder="Enter url"
                name="youtubeUrl"
                innerRef={register({
                  required: true,
                  type: 'text',
                  pattern: { value: regexPattern.YOUTUBE, message: validationMessages.YOUTUBE },
                })}
              />
              <span className="input-icon youtube" />
              <InputError error={errors.youtubeUrl} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
            </FormGroup>
            )
            }
          {
              betaPostData && betaPostData.shareType.spotify
            && (
            <FormGroup className={errors.spotifyUrl ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
              <Input
                type="text"
                placeholder="Enter url"
                name="spotifyUrl"
                innerRef={register({
                  required: true,
                  type: 'text',
                  pattern: { value: regexPattern.SPOTIFY, message: validationMessages.SPOTIFY },
                })}
              />
              <span className="input-icon spotify" />
              <InputError error={errors.spotifyUrl} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />

            </FormGroup>
            )
          }
        </div>
      </Form>
    </div>
  );

  return (
    <>
      {renderCompleteSection()}
    </>
  );
}

CompleteBetaPost.propTypes = {
  betaPostData: PropTypes.shape({
    segmentId: PropTypes.string,
    shareType: PropTypes.shape({
      facebook: PropTypes.bool,
      instagram: PropTypes.bool,
      twitter: PropTypes.bool,
      youtube: PropTypes.bool,
      spotify: PropTypes.bool,
    }),
  }),
  handlePublishBetaPost: PropTypes.func.isRequired,
};

CompleteBetaPost.defaultProps = {
  betaPostData: {},
};

export default CompleteBetaPost;
